import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";

function CreateServiceRequestRow({ submitterID, rerender, closeRow, agents, clients }) {
  const [formData, setFormData] = useState({
    editActivated: false,
    editModalIsOpen: false,
    showAddtlEdits: false,
    name: "",
    email: "",
    phone: "",
    type: "",
    mainAgent: "",
    associatedAgent: "",
    clientID: "",
    notes: ""
  });

  useEffect(() => {
    console.log("Contact Card Mounted");
  }, []);

  const handleInputChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.type === "checkbox" ? target.checked : target.value;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleServiceRequestSubmit = (e) => {
    e.preventDefault();
    console.log(formData);

    const serviceReqData = {
      type: formData.type,
      name: formData.name,
      requester: submitterID,
      requesterID: submitterID,
      email: formData.email,
      message: formData.notes,
      phone: formData.phone,
      agent: formData.associatedAgent,
      client: formData.clientID
    };

    console.log(serviceReqData);

    API.saveServiceRequest(serviceReqData)
      .then((_res) => {
        console.log("Saved Service Request");
        cogoToast.success("Service Request Saved!");
        rerender();
        closeRow();
      })
      .catch((err) => console.log(err));
  };

  return (
    <tr>
      <td>
        <input
          type="text"
          style={{ width: "100%" }}
          value={formData.name}
          onChange={handleInputChange}
          name="name"
          placeholder="Name"
        />
      </td>
      <td>
        <input
          type="text"
          style={{ width: "150px" }}
          value={formData.email}
          onChange={handleInputChange}
          name="email"
          placeholder="Email"
        />
      </td>
      <td>
        <input
          type="text"
          style={{ width: "150px" }}
          value={formData.phone}
          onChange={handleInputChange}
          name="phone"
          placeholder="Phone"
        />
      </td>
      <td>
        <select
          style={{ width: "100%" }}
          value={formData.type}
          onChange={handleInputChange}
          name="type"
        >
          <option value=""></option>
          <option value="billing">Billing</option>
          <option value="general">General</option>
          <option value="req-mortgage-doc">Lienholder</option>
          <option value="req-other">Other Request</option>
          <option value="renewal-quote">New Quote</option>
        </select>
      </td>
      <td>
        <input
          type="text"
          style={{ width: "250px" }}
          value={formData.notes}
          onChange={handleInputChange}
          name="notes"
          placeholder="Notes"
        />
      </td>
      <td>
        <button className="btn-success btn" onClick={(e) => handleServiceRequestSubmit(e)}>
          Submit
        </button>
      </td>
      <td>
        {agents ? (
          <select
            style={{ width: "150px" }}
            id="protegeDropMenu"
            value={formData.associatedAgent}
            onChange={handleInputChange}
            name="associatedAgent"
          >
            <option value="">--Associated Agent--</option>
            {agents.map((agent) => (
              <option key={agent._id} value={agent._id}>
                {agent.firstName} {agent.lastName}
              </option>
            ))}
          </select>
        ) : (
          <div>No agents yet</div>
        )}
      </td>
      <td>
        {clients ? (
          <select
            style={{ width: "150px" }}
            value={formData.clientID}
            onChange={handleInputChange}
            name="clientID"
          >
            <option value="">--Select a Client--</option>
            {clients
              .sort((a, b) => a.lastName.localeCompare(b.lastName))
              .map((client) => (
                <option key={client._id} value={client._id}>
                  {client.lastName} {client.firstName}
                </option>
              ))}
          </select>
        ) : (
          <div>No clients yet</div>
        )}
      </td>
    </tr>
  );
}

export default CreateServiceRequestRow;
